<template>
  <v-dialog v-model="dialogState" :retain-focus="false" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form v-model="isFormValid" ref="categoryValueForm">
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="editedItem.valName"
                  label="Value Name"
                  :rules="nameRule"
                  :counter="50"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="editedItem.valDesc"
                  label="Value Description"
                  :rules="requiredRule"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  v-model="editedItem.obsolete"
                  :items="['Y', 'N']"
                  label="Obsolete"
                  :rules="requiredRule"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete
                  v-model="editedItem.catId"
                  :rules="requiredRule"
                  required
                  :hint="`${editedItem.catId}`"
                  label="Select Category Name"
                  :items="categoryList.edges"
                  item-value="node.catId"
                  item-text="node.catName"
                >
                </v-autocomplete>
              </v-flex>

              <!-- <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="globalCatId"
                  label="Caegories"
                  :rules="requiredRule"
                  chips
                ></v-text-field>
              </v-flex> -->
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close">Cancel</v-btn>
        <v-btn
          :disabled="!isFormValid"
          color="secondary"
          text
          @click="actionName"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
/* eslint-disable prettier/prettier */
import { validation } from "../../mixins/validationMixin";
import { mapGetters } from "vuex";

export default {
  mixins: [validation],
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    formTitle: {
      type: String,
      required: true
    },
    index: {
      type: [Number, Boolean, String],
      required: true
    },
    editData: {
      type: [Object, Array, Boolean],
      default: () => false
    }
  },
  data() {
    return {
      isFormValid: true,
      editedItem: {
        catId: "",
        valName: "",
        valNameRus: "",
        valDesc: "",
        valDescRus: "",
        obsolete: "",
        updateSource: "test"
      },
      defaultItem: {
        catId: "",
        valName: "",
        valDesc: "",
        obsolete: "",
        updateSource: "test"
      },
      globalCatId: "123",
    }
  },
  computed: {
    ...mapGetters(["categoryList"]),
    dialogState: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit("set-dialog-to", val);
      }
    },
    actionName() {
      
      return this.index > 0 ? this.editCategoryValue : this.addNewCategoryValue;
    },
    /**
     * @return {Object || Boolean}
     */
    dataToEdit() {
      if (this.editData && typeof this.editData !== "boolean") {
        return this.editData;
      } else {
        return false;
      }
    },
  },
  methods: {
    /**
     * @param {Object || boolean}
     */
    setEditData(data) {
      if (data) {
        this.editedItem = { ...this.defaultItem, ...data};
        this.editedItem.catId = data.catId.toString();
      }
    },
    addNewCategoryValue() {
      const categoryName = this.categoryList.edges.filter(
        el => +el.node.catId === +this.editedItem.catId
      )[0].node.catName || "";
      this.$emit("set-loading", true);
      this.$store
        .dispatch("categoryValueMerge", {
          ...this.editedItem,
          catId: +this.editedItem.catId,
          catName: categoryName
        })
        .then(() => {
          this.$emit("set-loading", false);
          this.close();
          this.$toast.success("New category value has been added");
        })
        .catch(error => {
          console.error(error);
          this.$emit("set-loading", false);
          this.close();
        });
    },
    editCategoryValue() {
      const categoryName = this.categoryList.edges.filter(
        el => +el.node.catId === +this.editedItem.catId
      )[0].node.catName || "";
      this.$emit("set-loading", true);
      this.$store.dispatch("categoryValueUpdate", {
        ...this.editedItem,
        valId: +this.editedItem.valId,
        catId: +this.editedItem.catId,
        catName: categoryName,
      })
        .then(() => {
          this.$emit("set-loading", false);
          this.$toast.success("Category value has been updated")
          this.close();
        })
        .catch(error => {
          console.error(error);
          this.$emit("set-loading", false);
          this.close();
        })
    },
    close() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.$emit("close-form");
    }
  },
  mounted() {
    // ? Mounted hook can catch first update of editData
    this.setEditData(this.dataToEdit);
    console.log(this.dataToEdit, "dataToEdit");
  },
  watch: {
    dataToEdit() {
      this.setEditData(this.dataToEdit);
    }
  },
};
</script>
<style lang="scss"></style>